<section class="p-2 p-md-4">
  <div class="card">
    <div class="card-body">
      <label for="tipo-nome">Nome</label>
      <input [formControl]="form.controls.nome" id="tipo-nome" type="text" class="form-control input-validate" name="nome">
      <app-msg-erro [control]="form.controls.nome"></app-msg-erro>
      
      <label class="mt-3" for="tipo-nivel">Nível</label>
      <input [formControl]="form.controls.nivel" id="tipo-nivel" type="text" [textMask]="numberMask" class="form-control input-validate" name="nivel">
      <app-msg-erro [control]="form.controls.nivel"></app-msg-erro>

      <label class="mt-3" for="tipo-descricao">Descrição</label>
      <textarea [formControl]="form.controls.descricao" class="mw-100 form-control input-validate" name="descricao" id="tipo-descricao" name="descricao" rows="5"></textarea>
      <app-msg-erro [control]="form.controls.descricao"></app-msg-erro>
      <div class="mt-4" *ngIf="id">
        <app-checkbox [(checked)]="desativar" label="Desativar Tipo de Unidade" size="lg"></app-checkbox>
      </div>
    </div>
    <div class="card-footer bg-white text-right">
      <button [disabled]="form.invalid" (click)="concluir()" class="btn btn-lg btn-success px-5">Salvar</button>
    </div>
  </div>
</section>